/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth/route'
import { Route as AuthIndexImport } from './routes/_auth/index'
import { Route as PublicLoginImport } from './routes/_public.login'
import { Route as PublicForgotPasswordImport } from './routes/_public.forgot-password'

// Create Virtual Routes

const AuthUserProfileLazyImport = createFileRoute('/_auth/user-profile')()
const AuthDocumentsLazyImport = createFileRoute('/_auth/documents')()
const AuthChangePasswordLazyImport = createFileRoute('/_auth/change-password')()
const AuthVideoIndexLazyImport = createFileRoute('/_auth/video/')()
const AuthUsersIndexLazyImport = createFileRoute('/_auth/users/')()
const AuthTestsIndexLazyImport = createFileRoute('/_auth/tests/')()
const AuthScheduleIndexLazyImport = createFileRoute('/_auth/schedule/')()
const AuthLeaguesIndexLazyImport = createFileRoute('/_auth/leagues/')()
const AuthInvoicesIndexLazyImport = createFileRoute('/_auth/invoices/')()
const AuthBalanceIndexLazyImport = createFileRoute('/_auth/balance/')()
const AuthAvailabilityIndexLazyImport = createFileRoute(
  '/_auth/availability/',
)()
const AuthVideoVideoGroupIdLazyImport = createFileRoute(
  '/_auth/video/$videoGroupId',
)()
const AuthUsersNewLazyImport = createFileRoute('/_auth/users/new')()
const AuthUsersUserIdLazyImport = createFileRoute('/_auth/users/$userId')()
const AuthTestsNewLazyImport = createFileRoute('/_auth/tests/new')()
const AuthScheduleMyLazyImport = createFileRoute('/_auth/schedule/my')()
const AuthScheduleFullLazyImport = createFileRoute('/_auth/schedule/full')()
const AuthScheduleExportLazyImport = createFileRoute('/_auth/schedule/export')()
const AuthPostsNewLazyImport = createFileRoute('/_auth/posts/new')()
const AuthLeaguesNewLazyImport = createFileRoute('/_auth/leagues/new')()
const AuthLeaguesLeagueIdLazyImport = createFileRoute(
  '/_auth/leagues/$leagueId',
)()
const AuthJournalUsersRankingLazyImport = createFileRoute(
  '/_auth/journal/users-ranking',
)()
const AuthJournalRankingLazyImport = createFileRoute('/_auth/journal/ranking')()
const AuthJournalMyLazyImport = createFileRoute('/_auth/journal/my')()
const AuthJournalExportLazyImport = createFileRoute('/_auth/journal/export')()
const AuthJournalExpensesLazyImport = createFileRoute(
  '/_auth/journal/expenses',
)()
const AuthJournalBalanceLazyImport = createFileRoute('/_auth/journal/balance')()
const AuthInvoicesNewLazyImport = createFileRoute('/_auth/invoices/new')()
const AuthGamesUnconfirmedLazyImport = createFileRoute(
  '/_auth/games/unconfirmed',
)()
const AuthGamesNewLazyImport = createFileRoute('/_auth/games/new')()
const AuthGamesImportLazyImport = createFileRoute('/_auth/games/import')()
const AuthGamesAssignLazyImport = createFileRoute('/_auth/games/assign')()
const AuthGamesGameIdLazyImport = createFileRoute('/_auth/games/$gameId')()
const AuthEvaluationEvaluationIdLazyImport = createFileRoute(
  '/_auth/evaluation/$evaluationId',
)()
const AuthBalanceImportLazyImport = createFileRoute('/_auth/balance/import')()
const AuthAvailabilityUsersAvailabilityLazyImport = createFileRoute(
  '/_auth/availability/users-availability',
)()
const AuthAdminReportsLazyImport = createFileRoute('/_auth/admin/reports')()
const AuthAdminMailForUsersLazyImport = createFileRoute(
  '/_auth/admin/mail-for-users',
)()
const AuthLeaguesTripRankingsIndexLazyImport = createFileRoute(
  '/_auth/leagues/trip-rankings/',
)()
const AuthLeaguesLeagueGroupsIndexLazyImport = createFileRoute(
  '/_auth/leagues/league-groups/',
)()
const AuthUsersEditUserIdLazyImport = createFileRoute(
  '/_auth/users/edit/$userId',
)()
const AuthTestsEditTestIdLazyImport = createFileRoute(
  '/_auth/tests/edit/$testId',
)()
const AuthTestsTestIdSolveLazyImport = createFileRoute(
  '/_auth/tests/$testId/solve',
)()
const AuthTestsTestIdAnswersLazyImport = createFileRoute(
  '/_auth/tests/$testId/answers',
)()
const AuthPostsEditPostIdLazyImport = createFileRoute(
  '/_auth/posts/edit/$postId',
)()
const AuthLeaguesTripRankingsNewLazyImport = createFileRoute(
  '/_auth/leagues/trip-rankings/new',
)()
const AuthLeaguesTripRankingsTripRankingIdLazyImport = createFileRoute(
  '/_auth/leagues/trip-rankings/$tripRankingId',
)()
const AuthLeaguesLeagueGroupsNewLazyImport = createFileRoute(
  '/_auth/leagues/league-groups/new',
)()
const AuthLeaguesLeagueGroupsGroupIdLazyImport = createFileRoute(
  '/_auth/leagues/league-groups/$groupId',
)()
const AuthLeaguesEditLeagueIdLazyImport = createFileRoute(
  '/_auth/leagues/edit/$leagueId',
)()
const AuthJournalUserUserIdLazyImport = createFileRoute(
  '/_auth/journal/user/$userId',
)()
const AuthGamesEditGameIdLazyImport = createFileRoute(
  '/_auth/games/edit/$gameId',
)()
const AuthEvaluationEditGameIdLazyImport = createFileRoute(
  '/_auth/evaluation/edit/$gameId',
)()
const AuthAvailabilityUserUserIdLazyImport = createFileRoute(
  '/_auth/availability/user/$userId',
)()
const AuthLeaguesTripRankingsEditTripRankingIdLazyImport = createFileRoute(
  '/_auth/leagues/trip-rankings/edit/$tripRankingId',
)()
const AuthLeaguesLeagueGroupsEditGroupIdLazyImport = createFileRoute(
  '/_auth/leagues/league-groups/edit/$groupId',
)()

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthRouteRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthUserProfileLazyRoute = AuthUserProfileLazyImport.update({
  path: '/user-profile',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/user-profile.lazy').then((d) => d.Route),
)

const AuthDocumentsLazyRoute = AuthDocumentsLazyImport.update({
  path: '/documents',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/documents.lazy').then((d) => d.Route),
)

const AuthChangePasswordLazyRoute = AuthChangePasswordLazyImport.update({
  path: '/change-password',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/change-password.lazy').then((d) => d.Route),
)

const PublicLoginRoute = PublicLoginImport.update({
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)

const PublicForgotPasswordRoute = PublicForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)

const AuthVideoIndexLazyRoute = AuthVideoIndexLazyImport.update({
  path: '/video/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/video/index.lazy').then((d) => d.Route),
)

const AuthUsersIndexLazyRoute = AuthUsersIndexLazyImport.update({
  path: '/users/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/index.lazy').then((d) => d.Route),
)

const AuthTestsIndexLazyRoute = AuthTestsIndexLazyImport.update({
  path: '/tests/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/tests/index.lazy').then((d) => d.Route),
)

const AuthScheduleIndexLazyRoute = AuthScheduleIndexLazyImport.update({
  path: '/schedule/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/index.lazy').then((d) => d.Route),
)

const AuthLeaguesIndexLazyRoute = AuthLeaguesIndexLazyImport.update({
  path: '/leagues/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/leagues/index.lazy').then((d) => d.Route),
)

const AuthInvoicesIndexLazyRoute = AuthInvoicesIndexLazyImport.update({
  path: '/invoices/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/invoices/index.lazy').then((d) => d.Route),
)

const AuthBalanceIndexLazyRoute = AuthBalanceIndexLazyImport.update({
  path: '/balance/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/balance/index.lazy').then((d) => d.Route),
)

const AuthAvailabilityIndexLazyRoute = AuthAvailabilityIndexLazyImport.update({
  path: '/availability/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/availability/index.lazy').then((d) => d.Route),
)

const AuthVideoVideoGroupIdLazyRoute = AuthVideoVideoGroupIdLazyImport.update({
  path: '/video/$videoGroupId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/video/$videoGroupId.lazy').then((d) => d.Route),
)

const AuthUsersNewLazyRoute = AuthUsersNewLazyImport.update({
  path: '/users/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/new.lazy').then((d) => d.Route),
)

const AuthUsersUserIdLazyRoute = AuthUsersUserIdLazyImport.update({
  path: '/users/$userId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/$userId.lazy').then((d) => d.Route),
)

const AuthTestsNewLazyRoute = AuthTestsNewLazyImport.update({
  path: '/tests/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/tests/new.lazy').then((d) => d.Route),
)

const AuthScheduleMyLazyRoute = AuthScheduleMyLazyImport.update({
  path: '/schedule/my',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/my.lazy').then((d) => d.Route),
)

const AuthScheduleFullLazyRoute = AuthScheduleFullLazyImport.update({
  path: '/schedule/full',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/full.lazy').then((d) => d.Route),
)

const AuthScheduleExportLazyRoute = AuthScheduleExportLazyImport.update({
  path: '/schedule/export',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/export.lazy').then((d) => d.Route),
)

const AuthPostsNewLazyRoute = AuthPostsNewLazyImport.update({
  path: '/posts/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/posts/new.lazy').then((d) => d.Route),
)

const AuthLeaguesNewLazyRoute = AuthLeaguesNewLazyImport.update({
  path: '/leagues/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/leagues/new.lazy').then((d) => d.Route),
)

const AuthLeaguesLeagueIdLazyRoute = AuthLeaguesLeagueIdLazyImport.update({
  path: '/leagues/$leagueId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/leagues/$leagueId.lazy').then((d) => d.Route),
)

const AuthJournalUsersRankingLazyRoute =
  AuthJournalUsersRankingLazyImport.update({
    path: '/journal/users-ranking',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/journal/users-ranking.lazy').then((d) => d.Route),
  )

const AuthJournalRankingLazyRoute = AuthJournalRankingLazyImport.update({
  path: '/journal/ranking',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/ranking.lazy').then((d) => d.Route),
)

const AuthJournalMyLazyRoute = AuthJournalMyLazyImport.update({
  path: '/journal/my',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/my.lazy').then((d) => d.Route),
)

const AuthJournalExportLazyRoute = AuthJournalExportLazyImport.update({
  path: '/journal/export',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/export.lazy').then((d) => d.Route),
)

const AuthJournalExpensesLazyRoute = AuthJournalExpensesLazyImport.update({
  path: '/journal/expenses',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/expenses.lazy').then((d) => d.Route),
)

const AuthJournalBalanceLazyRoute = AuthJournalBalanceLazyImport.update({
  path: '/journal/balance',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/balance.lazy').then((d) => d.Route),
)

const AuthInvoicesNewLazyRoute = AuthInvoicesNewLazyImport.update({
  path: '/invoices/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/invoices/new.lazy').then((d) => d.Route),
)

const AuthGamesUnconfirmedLazyRoute = AuthGamesUnconfirmedLazyImport.update({
  path: '/games/unconfirmed',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/unconfirmed.lazy').then((d) => d.Route),
)

const AuthGamesNewLazyRoute = AuthGamesNewLazyImport.update({
  path: '/games/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/new.lazy').then((d) => d.Route),
)

const AuthGamesImportLazyRoute = AuthGamesImportLazyImport.update({
  path: '/games/import',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/import.lazy').then((d) => d.Route),
)

const AuthGamesAssignLazyRoute = AuthGamesAssignLazyImport.update({
  path: '/games/assign',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/assign.lazy').then((d) => d.Route),
)

const AuthGamesGameIdLazyRoute = AuthGamesGameIdLazyImport.update({
  path: '/games/$gameId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/$gameId.lazy').then((d) => d.Route),
)

const AuthEvaluationEvaluationIdLazyRoute =
  AuthEvaluationEvaluationIdLazyImport.update({
    path: '/evaluation/$evaluationId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/evaluation/$evaluationId.lazy').then((d) => d.Route),
  )

const AuthBalanceImportLazyRoute = AuthBalanceImportLazyImport.update({
  path: '/balance/import',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/balance/import.lazy').then((d) => d.Route),
)

const AuthAvailabilityUsersAvailabilityLazyRoute =
  AuthAvailabilityUsersAvailabilityLazyImport.update({
    path: '/availability/users-availability',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/availability/users-availability.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthAdminReportsLazyRoute = AuthAdminReportsLazyImport.update({
  path: '/admin/reports',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/admin/reports.lazy').then((d) => d.Route),
)

const AuthAdminMailForUsersLazyRoute = AuthAdminMailForUsersLazyImport.update({
  path: '/admin/mail-for-users',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/admin/mail-for-users.lazy').then((d) => d.Route),
)

const AuthLeaguesTripRankingsIndexLazyRoute =
  AuthLeaguesTripRankingsIndexLazyImport.update({
    path: '/leagues/trip-rankings/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/trip-rankings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthLeaguesLeagueGroupsIndexLazyRoute =
  AuthLeaguesLeagueGroupsIndexLazyImport.update({
    path: '/leagues/league-groups/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthUsersEditUserIdLazyRoute = AuthUsersEditUserIdLazyImport.update({
  path: '/users/edit/$userId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/edit.$userId.lazy').then((d) => d.Route),
)

const AuthTestsEditTestIdLazyRoute = AuthTestsEditTestIdLazyImport.update({
  path: '/tests/edit/$testId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/tests/edit.$testId.lazy').then((d) => d.Route),
)

const AuthTestsTestIdSolveLazyRoute = AuthTestsTestIdSolveLazyImport.update({
  path: '/tests/$testId/solve',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/tests/$testId.solve.lazy').then((d) => d.Route),
)

const AuthTestsTestIdAnswersLazyRoute = AuthTestsTestIdAnswersLazyImport.update(
  {
    path: '/tests/$testId/answers',
    getParentRoute: () => AuthRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_auth/tests/$testId.answers.lazy').then((d) => d.Route),
)

const AuthPostsEditPostIdLazyRoute = AuthPostsEditPostIdLazyImport.update({
  path: '/posts/edit/$postId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/posts/edit.$postId.lazy').then((d) => d.Route),
)

const AuthLeaguesTripRankingsNewLazyRoute =
  AuthLeaguesTripRankingsNewLazyImport.update({
    path: '/leagues/trip-rankings/new',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/trip-rankings/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthLeaguesTripRankingsTripRankingIdLazyRoute =
  AuthLeaguesTripRankingsTripRankingIdLazyImport.update({
    path: '/leagues/trip-rankings/$tripRankingId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/trip-rankings/$tripRankingId.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthLeaguesLeagueGroupsNewLazyRoute =
  AuthLeaguesLeagueGroupsNewLazyImport.update({
    path: '/leagues/league-groups/new',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/new.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthLeaguesLeagueGroupsGroupIdLazyRoute =
  AuthLeaguesLeagueGroupsGroupIdLazyImport.update({
    path: '/leagues/league-groups/$groupId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/$groupId.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthLeaguesEditLeagueIdLazyRoute =
  AuthLeaguesEditLeagueIdLazyImport.update({
    path: '/leagues/edit/$leagueId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/edit.$leagueId.lazy').then((d) => d.Route),
  )

const AuthJournalUserUserIdLazyRoute = AuthJournalUserUserIdLazyImport.update({
  path: '/journal/user/$userId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/user.$userId.lazy').then((d) => d.Route),
)

const AuthGamesEditGameIdLazyRoute = AuthGamesEditGameIdLazyImport.update({
  path: '/games/edit/$gameId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/edit.$gameId.lazy').then((d) => d.Route),
)

const AuthEvaluationEditGameIdLazyRoute =
  AuthEvaluationEditGameIdLazyImport.update({
    path: '/evaluation/edit/$gameId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/evaluation/edit.$gameId.lazy').then((d) => d.Route),
  )

const AuthAvailabilityUserUserIdLazyRoute =
  AuthAvailabilityUserUserIdLazyImport.update({
    path: '/availability/user/$userId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/availability/user.$userId.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthLeaguesTripRankingsEditTripRankingIdLazyRoute =
  AuthLeaguesTripRankingsEditTripRankingIdLazyImport.update({
    path: '/leagues/trip-rankings/edit/$tripRankingId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/leagues/trip-rankings/edit.$tripRankingId.lazy'
    ).then((d) => d.Route),
  )

const AuthLeaguesLeagueGroupsEditGroupIdLazyRoute =
  AuthLeaguesLeagueGroupsEditGroupIdLazyImport.update({
    path: '/leagues/league-groups/edit/$groupId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/edit.$groupId.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordImport
      parentRoute: typeof PublicImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicImport
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/documents': {
      id: '/_auth/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthDocumentsLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/user-profile': {
      id: '/_auth/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof AuthUserProfileLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/admin/mail-for-users': {
      id: '/_auth/admin/mail-for-users'
      path: '/admin/mail-for-users'
      fullPath: '/admin/mail-for-users'
      preLoaderRoute: typeof AuthAdminMailForUsersLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/admin/reports': {
      id: '/_auth/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AuthAdminReportsLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/availability/users-availability': {
      id: '/_auth/availability/users-availability'
      path: '/availability/users-availability'
      fullPath: '/availability/users-availability'
      preLoaderRoute: typeof AuthAvailabilityUsersAvailabilityLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/balance/import': {
      id: '/_auth/balance/import'
      path: '/balance/import'
      fullPath: '/balance/import'
      preLoaderRoute: typeof AuthBalanceImportLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/evaluation/$evaluationId': {
      id: '/_auth/evaluation/$evaluationId'
      path: '/evaluation/$evaluationId'
      fullPath: '/evaluation/$evaluationId'
      preLoaderRoute: typeof AuthEvaluationEvaluationIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/games/$gameId': {
      id: '/_auth/games/$gameId'
      path: '/games/$gameId'
      fullPath: '/games/$gameId'
      preLoaderRoute: typeof AuthGamesGameIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/games/assign': {
      id: '/_auth/games/assign'
      path: '/games/assign'
      fullPath: '/games/assign'
      preLoaderRoute: typeof AuthGamesAssignLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/games/import': {
      id: '/_auth/games/import'
      path: '/games/import'
      fullPath: '/games/import'
      preLoaderRoute: typeof AuthGamesImportLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/games/new': {
      id: '/_auth/games/new'
      path: '/games/new'
      fullPath: '/games/new'
      preLoaderRoute: typeof AuthGamesNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/games/unconfirmed': {
      id: '/_auth/games/unconfirmed'
      path: '/games/unconfirmed'
      fullPath: '/games/unconfirmed'
      preLoaderRoute: typeof AuthGamesUnconfirmedLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/invoices/new': {
      id: '/_auth/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthInvoicesNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/journal/balance': {
      id: '/_auth/journal/balance'
      path: '/journal/balance'
      fullPath: '/journal/balance'
      preLoaderRoute: typeof AuthJournalBalanceLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/journal/expenses': {
      id: '/_auth/journal/expenses'
      path: '/journal/expenses'
      fullPath: '/journal/expenses'
      preLoaderRoute: typeof AuthJournalExpensesLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/journal/export': {
      id: '/_auth/journal/export'
      path: '/journal/export'
      fullPath: '/journal/export'
      preLoaderRoute: typeof AuthJournalExportLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/journal/my': {
      id: '/_auth/journal/my'
      path: '/journal/my'
      fullPath: '/journal/my'
      preLoaderRoute: typeof AuthJournalMyLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/journal/ranking': {
      id: '/_auth/journal/ranking'
      path: '/journal/ranking'
      fullPath: '/journal/ranking'
      preLoaderRoute: typeof AuthJournalRankingLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/journal/users-ranking': {
      id: '/_auth/journal/users-ranking'
      path: '/journal/users-ranking'
      fullPath: '/journal/users-ranking'
      preLoaderRoute: typeof AuthJournalUsersRankingLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/$leagueId': {
      id: '/_auth/leagues/$leagueId'
      path: '/leagues/$leagueId'
      fullPath: '/leagues/$leagueId'
      preLoaderRoute: typeof AuthLeaguesLeagueIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/new': {
      id: '/_auth/leagues/new'
      path: '/leagues/new'
      fullPath: '/leagues/new'
      preLoaderRoute: typeof AuthLeaguesNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/posts/new': {
      id: '/_auth/posts/new'
      path: '/posts/new'
      fullPath: '/posts/new'
      preLoaderRoute: typeof AuthPostsNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/schedule/export': {
      id: '/_auth/schedule/export'
      path: '/schedule/export'
      fullPath: '/schedule/export'
      preLoaderRoute: typeof AuthScheduleExportLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/schedule/full': {
      id: '/_auth/schedule/full'
      path: '/schedule/full'
      fullPath: '/schedule/full'
      preLoaderRoute: typeof AuthScheduleFullLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/schedule/my': {
      id: '/_auth/schedule/my'
      path: '/schedule/my'
      fullPath: '/schedule/my'
      preLoaderRoute: typeof AuthScheduleMyLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/tests/new': {
      id: '/_auth/tests/new'
      path: '/tests/new'
      fullPath: '/tests/new'
      preLoaderRoute: typeof AuthTestsNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/users/$userId': {
      id: '/_auth/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthUsersUserIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/users/new': {
      id: '/_auth/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AuthUsersNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/video/$videoGroupId': {
      id: '/_auth/video/$videoGroupId'
      path: '/video/$videoGroupId'
      fullPath: '/video/$videoGroupId'
      preLoaderRoute: typeof AuthVideoVideoGroupIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/availability/': {
      id: '/_auth/availability/'
      path: '/availability'
      fullPath: '/availability'
      preLoaderRoute: typeof AuthAvailabilityIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/balance/': {
      id: '/_auth/balance/'
      path: '/balance'
      fullPath: '/balance'
      preLoaderRoute: typeof AuthBalanceIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/invoices/': {
      id: '/_auth/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthInvoicesIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/': {
      id: '/_auth/leagues/'
      path: '/leagues'
      fullPath: '/leagues'
      preLoaderRoute: typeof AuthLeaguesIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/schedule/': {
      id: '/_auth/schedule/'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthScheduleIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/tests/': {
      id: '/_auth/tests/'
      path: '/tests'
      fullPath: '/tests'
      preLoaderRoute: typeof AuthTestsIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/video/': {
      id: '/_auth/video/'
      path: '/video'
      fullPath: '/video'
      preLoaderRoute: typeof AuthVideoIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/availability/user/$userId': {
      id: '/_auth/availability/user/$userId'
      path: '/availability/user/$userId'
      fullPath: '/availability/user/$userId'
      preLoaderRoute: typeof AuthAvailabilityUserUserIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/evaluation/edit/$gameId': {
      id: '/_auth/evaluation/edit/$gameId'
      path: '/evaluation/edit/$gameId'
      fullPath: '/evaluation/edit/$gameId'
      preLoaderRoute: typeof AuthEvaluationEditGameIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/games/edit/$gameId': {
      id: '/_auth/games/edit/$gameId'
      path: '/games/edit/$gameId'
      fullPath: '/games/edit/$gameId'
      preLoaderRoute: typeof AuthGamesEditGameIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/journal/user/$userId': {
      id: '/_auth/journal/user/$userId'
      path: '/journal/user/$userId'
      fullPath: '/journal/user/$userId'
      preLoaderRoute: typeof AuthJournalUserUserIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/edit/$leagueId': {
      id: '/_auth/leagues/edit/$leagueId'
      path: '/leagues/edit/$leagueId'
      fullPath: '/leagues/edit/$leagueId'
      preLoaderRoute: typeof AuthLeaguesEditLeagueIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/league-groups/$groupId': {
      id: '/_auth/leagues/league-groups/$groupId'
      path: '/leagues/league-groups/$groupId'
      fullPath: '/leagues/league-groups/$groupId'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsGroupIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/league-groups/new': {
      id: '/_auth/leagues/league-groups/new'
      path: '/leagues/league-groups/new'
      fullPath: '/leagues/league-groups/new'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/trip-rankings/$tripRankingId': {
      id: '/_auth/leagues/trip-rankings/$tripRankingId'
      path: '/leagues/trip-rankings/$tripRankingId'
      fullPath: '/leagues/trip-rankings/$tripRankingId'
      preLoaderRoute: typeof AuthLeaguesTripRankingsTripRankingIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/trip-rankings/new': {
      id: '/_auth/leagues/trip-rankings/new'
      path: '/leagues/trip-rankings/new'
      fullPath: '/leagues/trip-rankings/new'
      preLoaderRoute: typeof AuthLeaguesTripRankingsNewLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/posts/edit/$postId': {
      id: '/_auth/posts/edit/$postId'
      path: '/posts/edit/$postId'
      fullPath: '/posts/edit/$postId'
      preLoaderRoute: typeof AuthPostsEditPostIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/tests/$testId/answers': {
      id: '/_auth/tests/$testId/answers'
      path: '/tests/$testId/answers'
      fullPath: '/tests/$testId/answers'
      preLoaderRoute: typeof AuthTestsTestIdAnswersLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/tests/$testId/solve': {
      id: '/_auth/tests/$testId/solve'
      path: '/tests/$testId/solve'
      fullPath: '/tests/$testId/solve'
      preLoaderRoute: typeof AuthTestsTestIdSolveLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/tests/edit/$testId': {
      id: '/_auth/tests/edit/$testId'
      path: '/tests/edit/$testId'
      fullPath: '/tests/edit/$testId'
      preLoaderRoute: typeof AuthTestsEditTestIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/users/edit/$userId': {
      id: '/_auth/users/edit/$userId'
      path: '/users/edit/$userId'
      fullPath: '/users/edit/$userId'
      preLoaderRoute: typeof AuthUsersEditUserIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/league-groups/': {
      id: '/_auth/leagues/league-groups/'
      path: '/leagues/league-groups'
      fullPath: '/leagues/league-groups'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/trip-rankings/': {
      id: '/_auth/leagues/trip-rankings/'
      path: '/leagues/trip-rankings'
      fullPath: '/leagues/trip-rankings'
      preLoaderRoute: typeof AuthLeaguesTripRankingsIndexLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/league-groups/edit/$groupId': {
      id: '/_auth/leagues/league-groups/edit/$groupId'
      path: '/leagues/league-groups/edit/$groupId'
      fullPath: '/leagues/league-groups/edit/$groupId'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsEditGroupIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/leagues/trip-rankings/edit/$tripRankingId': {
      id: '/_auth/leagues/trip-rankings/edit/$tripRankingId'
      path: '/leagues/trip-rankings/edit/$tripRankingId'
      fullPath: '/leagues/trip-rankings/edit/$tripRankingId'
      preLoaderRoute: typeof AuthLeaguesTripRankingsEditTripRankingIdLazyImport
      parentRoute: typeof AuthRouteImport
    }
  }
}

// Create and export the route tree

interface AuthRouteRouteChildren {
  AuthChangePasswordLazyRoute: typeof AuthChangePasswordLazyRoute
  AuthDocumentsLazyRoute: typeof AuthDocumentsLazyRoute
  AuthUserProfileLazyRoute: typeof AuthUserProfileLazyRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdminMailForUsersLazyRoute: typeof AuthAdminMailForUsersLazyRoute
  AuthAdminReportsLazyRoute: typeof AuthAdminReportsLazyRoute
  AuthAvailabilityUsersAvailabilityLazyRoute: typeof AuthAvailabilityUsersAvailabilityLazyRoute
  AuthBalanceImportLazyRoute: typeof AuthBalanceImportLazyRoute
  AuthEvaluationEvaluationIdLazyRoute: typeof AuthEvaluationEvaluationIdLazyRoute
  AuthGamesGameIdLazyRoute: typeof AuthGamesGameIdLazyRoute
  AuthGamesAssignLazyRoute: typeof AuthGamesAssignLazyRoute
  AuthGamesImportLazyRoute: typeof AuthGamesImportLazyRoute
  AuthGamesNewLazyRoute: typeof AuthGamesNewLazyRoute
  AuthGamesUnconfirmedLazyRoute: typeof AuthGamesUnconfirmedLazyRoute
  AuthInvoicesNewLazyRoute: typeof AuthInvoicesNewLazyRoute
  AuthJournalBalanceLazyRoute: typeof AuthJournalBalanceLazyRoute
  AuthJournalExpensesLazyRoute: typeof AuthJournalExpensesLazyRoute
  AuthJournalExportLazyRoute: typeof AuthJournalExportLazyRoute
  AuthJournalMyLazyRoute: typeof AuthJournalMyLazyRoute
  AuthJournalRankingLazyRoute: typeof AuthJournalRankingLazyRoute
  AuthJournalUsersRankingLazyRoute: typeof AuthJournalUsersRankingLazyRoute
  AuthLeaguesLeagueIdLazyRoute: typeof AuthLeaguesLeagueIdLazyRoute
  AuthLeaguesNewLazyRoute: typeof AuthLeaguesNewLazyRoute
  AuthPostsNewLazyRoute: typeof AuthPostsNewLazyRoute
  AuthScheduleExportLazyRoute: typeof AuthScheduleExportLazyRoute
  AuthScheduleFullLazyRoute: typeof AuthScheduleFullLazyRoute
  AuthScheduleMyLazyRoute: typeof AuthScheduleMyLazyRoute
  AuthTestsNewLazyRoute: typeof AuthTestsNewLazyRoute
  AuthUsersUserIdLazyRoute: typeof AuthUsersUserIdLazyRoute
  AuthUsersNewLazyRoute: typeof AuthUsersNewLazyRoute
  AuthVideoVideoGroupIdLazyRoute: typeof AuthVideoVideoGroupIdLazyRoute
  AuthAvailabilityIndexLazyRoute: typeof AuthAvailabilityIndexLazyRoute
  AuthBalanceIndexLazyRoute: typeof AuthBalanceIndexLazyRoute
  AuthInvoicesIndexLazyRoute: typeof AuthInvoicesIndexLazyRoute
  AuthLeaguesIndexLazyRoute: typeof AuthLeaguesIndexLazyRoute
  AuthScheduleIndexLazyRoute: typeof AuthScheduleIndexLazyRoute
  AuthTestsIndexLazyRoute: typeof AuthTestsIndexLazyRoute
  AuthUsersIndexLazyRoute: typeof AuthUsersIndexLazyRoute
  AuthVideoIndexLazyRoute: typeof AuthVideoIndexLazyRoute
  AuthAvailabilityUserUserIdLazyRoute: typeof AuthAvailabilityUserUserIdLazyRoute
  AuthEvaluationEditGameIdLazyRoute: typeof AuthEvaluationEditGameIdLazyRoute
  AuthGamesEditGameIdLazyRoute: typeof AuthGamesEditGameIdLazyRoute
  AuthJournalUserUserIdLazyRoute: typeof AuthJournalUserUserIdLazyRoute
  AuthLeaguesEditLeagueIdLazyRoute: typeof AuthLeaguesEditLeagueIdLazyRoute
  AuthLeaguesLeagueGroupsGroupIdLazyRoute: typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  AuthLeaguesLeagueGroupsNewLazyRoute: typeof AuthLeaguesLeagueGroupsNewLazyRoute
  AuthLeaguesTripRankingsTripRankingIdLazyRoute: typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  AuthLeaguesTripRankingsNewLazyRoute: typeof AuthLeaguesTripRankingsNewLazyRoute
  AuthPostsEditPostIdLazyRoute: typeof AuthPostsEditPostIdLazyRoute
  AuthTestsTestIdAnswersLazyRoute: typeof AuthTestsTestIdAnswersLazyRoute
  AuthTestsTestIdSolveLazyRoute: typeof AuthTestsTestIdSolveLazyRoute
  AuthTestsEditTestIdLazyRoute: typeof AuthTestsEditTestIdLazyRoute
  AuthUsersEditUserIdLazyRoute: typeof AuthUsersEditUserIdLazyRoute
  AuthLeaguesLeagueGroupsIndexLazyRoute: typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  AuthLeaguesTripRankingsIndexLazyRoute: typeof AuthLeaguesTripRankingsIndexLazyRoute
  AuthLeaguesLeagueGroupsEditGroupIdLazyRoute: typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  AuthLeaguesTripRankingsEditTripRankingIdLazyRoute: typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthChangePasswordLazyRoute: AuthChangePasswordLazyRoute,
  AuthDocumentsLazyRoute: AuthDocumentsLazyRoute,
  AuthUserProfileLazyRoute: AuthUserProfileLazyRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdminMailForUsersLazyRoute: AuthAdminMailForUsersLazyRoute,
  AuthAdminReportsLazyRoute: AuthAdminReportsLazyRoute,
  AuthAvailabilityUsersAvailabilityLazyRoute:
    AuthAvailabilityUsersAvailabilityLazyRoute,
  AuthBalanceImportLazyRoute: AuthBalanceImportLazyRoute,
  AuthEvaluationEvaluationIdLazyRoute: AuthEvaluationEvaluationIdLazyRoute,
  AuthGamesGameIdLazyRoute: AuthGamesGameIdLazyRoute,
  AuthGamesAssignLazyRoute: AuthGamesAssignLazyRoute,
  AuthGamesImportLazyRoute: AuthGamesImportLazyRoute,
  AuthGamesNewLazyRoute: AuthGamesNewLazyRoute,
  AuthGamesUnconfirmedLazyRoute: AuthGamesUnconfirmedLazyRoute,
  AuthInvoicesNewLazyRoute: AuthInvoicesNewLazyRoute,
  AuthJournalBalanceLazyRoute: AuthJournalBalanceLazyRoute,
  AuthJournalExpensesLazyRoute: AuthJournalExpensesLazyRoute,
  AuthJournalExportLazyRoute: AuthJournalExportLazyRoute,
  AuthJournalMyLazyRoute: AuthJournalMyLazyRoute,
  AuthJournalRankingLazyRoute: AuthJournalRankingLazyRoute,
  AuthJournalUsersRankingLazyRoute: AuthJournalUsersRankingLazyRoute,
  AuthLeaguesLeagueIdLazyRoute: AuthLeaguesLeagueIdLazyRoute,
  AuthLeaguesNewLazyRoute: AuthLeaguesNewLazyRoute,
  AuthPostsNewLazyRoute: AuthPostsNewLazyRoute,
  AuthScheduleExportLazyRoute: AuthScheduleExportLazyRoute,
  AuthScheduleFullLazyRoute: AuthScheduleFullLazyRoute,
  AuthScheduleMyLazyRoute: AuthScheduleMyLazyRoute,
  AuthTestsNewLazyRoute: AuthTestsNewLazyRoute,
  AuthUsersUserIdLazyRoute: AuthUsersUserIdLazyRoute,
  AuthUsersNewLazyRoute: AuthUsersNewLazyRoute,
  AuthVideoVideoGroupIdLazyRoute: AuthVideoVideoGroupIdLazyRoute,
  AuthAvailabilityIndexLazyRoute: AuthAvailabilityIndexLazyRoute,
  AuthBalanceIndexLazyRoute: AuthBalanceIndexLazyRoute,
  AuthInvoicesIndexLazyRoute: AuthInvoicesIndexLazyRoute,
  AuthLeaguesIndexLazyRoute: AuthLeaguesIndexLazyRoute,
  AuthScheduleIndexLazyRoute: AuthScheduleIndexLazyRoute,
  AuthTestsIndexLazyRoute: AuthTestsIndexLazyRoute,
  AuthUsersIndexLazyRoute: AuthUsersIndexLazyRoute,
  AuthVideoIndexLazyRoute: AuthVideoIndexLazyRoute,
  AuthAvailabilityUserUserIdLazyRoute: AuthAvailabilityUserUserIdLazyRoute,
  AuthEvaluationEditGameIdLazyRoute: AuthEvaluationEditGameIdLazyRoute,
  AuthGamesEditGameIdLazyRoute: AuthGamesEditGameIdLazyRoute,
  AuthJournalUserUserIdLazyRoute: AuthJournalUserUserIdLazyRoute,
  AuthLeaguesEditLeagueIdLazyRoute: AuthLeaguesEditLeagueIdLazyRoute,
  AuthLeaguesLeagueGroupsGroupIdLazyRoute:
    AuthLeaguesLeagueGroupsGroupIdLazyRoute,
  AuthLeaguesLeagueGroupsNewLazyRoute: AuthLeaguesLeagueGroupsNewLazyRoute,
  AuthLeaguesTripRankingsTripRankingIdLazyRoute:
    AuthLeaguesTripRankingsTripRankingIdLazyRoute,
  AuthLeaguesTripRankingsNewLazyRoute: AuthLeaguesTripRankingsNewLazyRoute,
  AuthPostsEditPostIdLazyRoute: AuthPostsEditPostIdLazyRoute,
  AuthTestsTestIdAnswersLazyRoute: AuthTestsTestIdAnswersLazyRoute,
  AuthTestsTestIdSolveLazyRoute: AuthTestsTestIdSolveLazyRoute,
  AuthTestsEditTestIdLazyRoute: AuthTestsEditTestIdLazyRoute,
  AuthUsersEditUserIdLazyRoute: AuthUsersEditUserIdLazyRoute,
  AuthLeaguesLeagueGroupsIndexLazyRoute: AuthLeaguesLeagueGroupsIndexLazyRoute,
  AuthLeaguesTripRankingsIndexLazyRoute: AuthLeaguesTripRankingsIndexLazyRoute,
  AuthLeaguesLeagueGroupsEditGroupIdLazyRoute:
    AuthLeaguesLeagueGroupsEditGroupIdLazyRoute,
  AuthLeaguesTripRankingsEditTripRankingIdLazyRoute:
    AuthLeaguesTripRankingsEditTripRankingIdLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof PublicRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/change-password': typeof AuthChangePasswordLazyRoute
  '/documents': typeof AuthDocumentsLazyRoute
  '/user-profile': typeof AuthUserProfileLazyRoute
  '/': typeof AuthIndexRoute
  '/admin/mail-for-users': typeof AuthAdminMailForUsersLazyRoute
  '/admin/reports': typeof AuthAdminReportsLazyRoute
  '/availability/users-availability': typeof AuthAvailabilityUsersAvailabilityLazyRoute
  '/balance/import': typeof AuthBalanceImportLazyRoute
  '/evaluation/$evaluationId': typeof AuthEvaluationEvaluationIdLazyRoute
  '/games/$gameId': typeof AuthGamesGameIdLazyRoute
  '/games/assign': typeof AuthGamesAssignLazyRoute
  '/games/import': typeof AuthGamesImportLazyRoute
  '/games/new': typeof AuthGamesNewLazyRoute
  '/games/unconfirmed': typeof AuthGamesUnconfirmedLazyRoute
  '/invoices/new': typeof AuthInvoicesNewLazyRoute
  '/journal/balance': typeof AuthJournalBalanceLazyRoute
  '/journal/expenses': typeof AuthJournalExpensesLazyRoute
  '/journal/export': typeof AuthJournalExportLazyRoute
  '/journal/my': typeof AuthJournalMyLazyRoute
  '/journal/ranking': typeof AuthJournalRankingLazyRoute
  '/journal/users-ranking': typeof AuthJournalUsersRankingLazyRoute
  '/leagues/$leagueId': typeof AuthLeaguesLeagueIdLazyRoute
  '/leagues/new': typeof AuthLeaguesNewLazyRoute
  '/posts/new': typeof AuthPostsNewLazyRoute
  '/schedule/export': typeof AuthScheduleExportLazyRoute
  '/schedule/full': typeof AuthScheduleFullLazyRoute
  '/schedule/my': typeof AuthScheduleMyLazyRoute
  '/tests/new': typeof AuthTestsNewLazyRoute
  '/users/$userId': typeof AuthUsersUserIdLazyRoute
  '/users/new': typeof AuthUsersNewLazyRoute
  '/video/$videoGroupId': typeof AuthVideoVideoGroupIdLazyRoute
  '/availability': typeof AuthAvailabilityIndexLazyRoute
  '/balance': typeof AuthBalanceIndexLazyRoute
  '/invoices': typeof AuthInvoicesIndexLazyRoute
  '/leagues': typeof AuthLeaguesIndexLazyRoute
  '/schedule': typeof AuthScheduleIndexLazyRoute
  '/tests': typeof AuthTestsIndexLazyRoute
  '/users': typeof AuthUsersIndexLazyRoute
  '/video': typeof AuthVideoIndexLazyRoute
  '/availability/user/$userId': typeof AuthAvailabilityUserUserIdLazyRoute
  '/evaluation/edit/$gameId': typeof AuthEvaluationEditGameIdLazyRoute
  '/games/edit/$gameId': typeof AuthGamesEditGameIdLazyRoute
  '/journal/user/$userId': typeof AuthJournalUserUserIdLazyRoute
  '/leagues/edit/$leagueId': typeof AuthLeaguesEditLeagueIdLazyRoute
  '/leagues/league-groups/$groupId': typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  '/leagues/league-groups/new': typeof AuthLeaguesLeagueGroupsNewLazyRoute
  '/leagues/trip-rankings/$tripRankingId': typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  '/leagues/trip-rankings/new': typeof AuthLeaguesTripRankingsNewLazyRoute
  '/posts/edit/$postId': typeof AuthPostsEditPostIdLazyRoute
  '/tests/$testId/answers': typeof AuthTestsTestIdAnswersLazyRoute
  '/tests/$testId/solve': typeof AuthTestsTestIdSolveLazyRoute
  '/tests/edit/$testId': typeof AuthTestsEditTestIdLazyRoute
  '/users/edit/$userId': typeof AuthUsersEditUserIdLazyRoute
  '/leagues/league-groups': typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  '/leagues/trip-rankings': typeof AuthLeaguesTripRankingsIndexLazyRoute
  '/leagues/league-groups/edit/$groupId': typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  '/leagues/trip-rankings/edit/$tripRankingId': typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}

export interface FileRoutesByTo {
  '': typeof PublicRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/change-password': typeof AuthChangePasswordLazyRoute
  '/documents': typeof AuthDocumentsLazyRoute
  '/user-profile': typeof AuthUserProfileLazyRoute
  '/': typeof AuthIndexRoute
  '/admin/mail-for-users': typeof AuthAdminMailForUsersLazyRoute
  '/admin/reports': typeof AuthAdminReportsLazyRoute
  '/availability/users-availability': typeof AuthAvailabilityUsersAvailabilityLazyRoute
  '/balance/import': typeof AuthBalanceImportLazyRoute
  '/evaluation/$evaluationId': typeof AuthEvaluationEvaluationIdLazyRoute
  '/games/$gameId': typeof AuthGamesGameIdLazyRoute
  '/games/assign': typeof AuthGamesAssignLazyRoute
  '/games/import': typeof AuthGamesImportLazyRoute
  '/games/new': typeof AuthGamesNewLazyRoute
  '/games/unconfirmed': typeof AuthGamesUnconfirmedLazyRoute
  '/invoices/new': typeof AuthInvoicesNewLazyRoute
  '/journal/balance': typeof AuthJournalBalanceLazyRoute
  '/journal/expenses': typeof AuthJournalExpensesLazyRoute
  '/journal/export': typeof AuthJournalExportLazyRoute
  '/journal/my': typeof AuthJournalMyLazyRoute
  '/journal/ranking': typeof AuthJournalRankingLazyRoute
  '/journal/users-ranking': typeof AuthJournalUsersRankingLazyRoute
  '/leagues/$leagueId': typeof AuthLeaguesLeagueIdLazyRoute
  '/leagues/new': typeof AuthLeaguesNewLazyRoute
  '/posts/new': typeof AuthPostsNewLazyRoute
  '/schedule/export': typeof AuthScheduleExportLazyRoute
  '/schedule/full': typeof AuthScheduleFullLazyRoute
  '/schedule/my': typeof AuthScheduleMyLazyRoute
  '/tests/new': typeof AuthTestsNewLazyRoute
  '/users/$userId': typeof AuthUsersUserIdLazyRoute
  '/users/new': typeof AuthUsersNewLazyRoute
  '/video/$videoGroupId': typeof AuthVideoVideoGroupIdLazyRoute
  '/availability': typeof AuthAvailabilityIndexLazyRoute
  '/balance': typeof AuthBalanceIndexLazyRoute
  '/invoices': typeof AuthInvoicesIndexLazyRoute
  '/leagues': typeof AuthLeaguesIndexLazyRoute
  '/schedule': typeof AuthScheduleIndexLazyRoute
  '/tests': typeof AuthTestsIndexLazyRoute
  '/users': typeof AuthUsersIndexLazyRoute
  '/video': typeof AuthVideoIndexLazyRoute
  '/availability/user/$userId': typeof AuthAvailabilityUserUserIdLazyRoute
  '/evaluation/edit/$gameId': typeof AuthEvaluationEditGameIdLazyRoute
  '/games/edit/$gameId': typeof AuthGamesEditGameIdLazyRoute
  '/journal/user/$userId': typeof AuthJournalUserUserIdLazyRoute
  '/leagues/edit/$leagueId': typeof AuthLeaguesEditLeagueIdLazyRoute
  '/leagues/league-groups/$groupId': typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  '/leagues/league-groups/new': typeof AuthLeaguesLeagueGroupsNewLazyRoute
  '/leagues/trip-rankings/$tripRankingId': typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  '/leagues/trip-rankings/new': typeof AuthLeaguesTripRankingsNewLazyRoute
  '/posts/edit/$postId': typeof AuthPostsEditPostIdLazyRoute
  '/tests/$testId/answers': typeof AuthTestsTestIdAnswersLazyRoute
  '/tests/$testId/solve': typeof AuthTestsTestIdSolveLazyRoute
  '/tests/edit/$testId': typeof AuthTestsEditTestIdLazyRoute
  '/users/edit/$userId': typeof AuthUsersEditUserIdLazyRoute
  '/leagues/league-groups': typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  '/leagues/trip-rankings': typeof AuthLeaguesTripRankingsIndexLazyRoute
  '/leagues/league-groups/edit/$groupId': typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  '/leagues/trip-rankings/edit/$tripRankingId': typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_auth/change-password': typeof AuthChangePasswordLazyRoute
  '/_auth/documents': typeof AuthDocumentsLazyRoute
  '/_auth/user-profile': typeof AuthUserProfileLazyRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/mail-for-users': typeof AuthAdminMailForUsersLazyRoute
  '/_auth/admin/reports': typeof AuthAdminReportsLazyRoute
  '/_auth/availability/users-availability': typeof AuthAvailabilityUsersAvailabilityLazyRoute
  '/_auth/balance/import': typeof AuthBalanceImportLazyRoute
  '/_auth/evaluation/$evaluationId': typeof AuthEvaluationEvaluationIdLazyRoute
  '/_auth/games/$gameId': typeof AuthGamesGameIdLazyRoute
  '/_auth/games/assign': typeof AuthGamesAssignLazyRoute
  '/_auth/games/import': typeof AuthGamesImportLazyRoute
  '/_auth/games/new': typeof AuthGamesNewLazyRoute
  '/_auth/games/unconfirmed': typeof AuthGamesUnconfirmedLazyRoute
  '/_auth/invoices/new': typeof AuthInvoicesNewLazyRoute
  '/_auth/journal/balance': typeof AuthJournalBalanceLazyRoute
  '/_auth/journal/expenses': typeof AuthJournalExpensesLazyRoute
  '/_auth/journal/export': typeof AuthJournalExportLazyRoute
  '/_auth/journal/my': typeof AuthJournalMyLazyRoute
  '/_auth/journal/ranking': typeof AuthJournalRankingLazyRoute
  '/_auth/journal/users-ranking': typeof AuthJournalUsersRankingLazyRoute
  '/_auth/leagues/$leagueId': typeof AuthLeaguesLeagueIdLazyRoute
  '/_auth/leagues/new': typeof AuthLeaguesNewLazyRoute
  '/_auth/posts/new': typeof AuthPostsNewLazyRoute
  '/_auth/schedule/export': typeof AuthScheduleExportLazyRoute
  '/_auth/schedule/full': typeof AuthScheduleFullLazyRoute
  '/_auth/schedule/my': typeof AuthScheduleMyLazyRoute
  '/_auth/tests/new': typeof AuthTestsNewLazyRoute
  '/_auth/users/$userId': typeof AuthUsersUserIdLazyRoute
  '/_auth/users/new': typeof AuthUsersNewLazyRoute
  '/_auth/video/$videoGroupId': typeof AuthVideoVideoGroupIdLazyRoute
  '/_auth/availability/': typeof AuthAvailabilityIndexLazyRoute
  '/_auth/balance/': typeof AuthBalanceIndexLazyRoute
  '/_auth/invoices/': typeof AuthInvoicesIndexLazyRoute
  '/_auth/leagues/': typeof AuthLeaguesIndexLazyRoute
  '/_auth/schedule/': typeof AuthScheduleIndexLazyRoute
  '/_auth/tests/': typeof AuthTestsIndexLazyRoute
  '/_auth/users/': typeof AuthUsersIndexLazyRoute
  '/_auth/video/': typeof AuthVideoIndexLazyRoute
  '/_auth/availability/user/$userId': typeof AuthAvailabilityUserUserIdLazyRoute
  '/_auth/evaluation/edit/$gameId': typeof AuthEvaluationEditGameIdLazyRoute
  '/_auth/games/edit/$gameId': typeof AuthGamesEditGameIdLazyRoute
  '/_auth/journal/user/$userId': typeof AuthJournalUserUserIdLazyRoute
  '/_auth/leagues/edit/$leagueId': typeof AuthLeaguesEditLeagueIdLazyRoute
  '/_auth/leagues/league-groups/$groupId': typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  '/_auth/leagues/league-groups/new': typeof AuthLeaguesLeagueGroupsNewLazyRoute
  '/_auth/leagues/trip-rankings/$tripRankingId': typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  '/_auth/leagues/trip-rankings/new': typeof AuthLeaguesTripRankingsNewLazyRoute
  '/_auth/posts/edit/$postId': typeof AuthPostsEditPostIdLazyRoute
  '/_auth/tests/$testId/answers': typeof AuthTestsTestIdAnswersLazyRoute
  '/_auth/tests/$testId/solve': typeof AuthTestsTestIdSolveLazyRoute
  '/_auth/tests/edit/$testId': typeof AuthTestsEditTestIdLazyRoute
  '/_auth/users/edit/$userId': typeof AuthUsersEditUserIdLazyRoute
  '/_auth/leagues/league-groups/': typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  '/_auth/leagues/trip-rankings/': typeof AuthLeaguesTripRankingsIndexLazyRoute
  '/_auth/leagues/league-groups/edit/$groupId': typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  '/_auth/leagues/trip-rankings/edit/$tripRankingId': typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/forgot-password'
    | '/login'
    | '/change-password'
    | '/documents'
    | '/user-profile'
    | '/'
    | '/admin/mail-for-users'
    | '/admin/reports'
    | '/availability/users-availability'
    | '/balance/import'
    | '/evaluation/$evaluationId'
    | '/games/$gameId'
    | '/games/assign'
    | '/games/import'
    | '/games/new'
    | '/games/unconfirmed'
    | '/invoices/new'
    | '/journal/balance'
    | '/journal/expenses'
    | '/journal/export'
    | '/journal/my'
    | '/journal/ranking'
    | '/journal/users-ranking'
    | '/leagues/$leagueId'
    | '/leagues/new'
    | '/posts/new'
    | '/schedule/export'
    | '/schedule/full'
    | '/schedule/my'
    | '/tests/new'
    | '/users/$userId'
    | '/users/new'
    | '/video/$videoGroupId'
    | '/availability'
    | '/balance'
    | '/invoices'
    | '/leagues'
    | '/schedule'
    | '/tests'
    | '/users'
    | '/video'
    | '/availability/user/$userId'
    | '/evaluation/edit/$gameId'
    | '/games/edit/$gameId'
    | '/journal/user/$userId'
    | '/leagues/edit/$leagueId'
    | '/leagues/league-groups/$groupId'
    | '/leagues/league-groups/new'
    | '/leagues/trip-rankings/$tripRankingId'
    | '/leagues/trip-rankings/new'
    | '/posts/edit/$postId'
    | '/tests/$testId/answers'
    | '/tests/$testId/solve'
    | '/tests/edit/$testId'
    | '/users/edit/$userId'
    | '/leagues/league-groups'
    | '/leagues/trip-rankings'
    | '/leagues/league-groups/edit/$groupId'
    | '/leagues/trip-rankings/edit/$tripRankingId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/forgot-password'
    | '/login'
    | '/change-password'
    | '/documents'
    | '/user-profile'
    | '/'
    | '/admin/mail-for-users'
    | '/admin/reports'
    | '/availability/users-availability'
    | '/balance/import'
    | '/evaluation/$evaluationId'
    | '/games/$gameId'
    | '/games/assign'
    | '/games/import'
    | '/games/new'
    | '/games/unconfirmed'
    | '/invoices/new'
    | '/journal/balance'
    | '/journal/expenses'
    | '/journal/export'
    | '/journal/my'
    | '/journal/ranking'
    | '/journal/users-ranking'
    | '/leagues/$leagueId'
    | '/leagues/new'
    | '/posts/new'
    | '/schedule/export'
    | '/schedule/full'
    | '/schedule/my'
    | '/tests/new'
    | '/users/$userId'
    | '/users/new'
    | '/video/$videoGroupId'
    | '/availability'
    | '/balance'
    | '/invoices'
    | '/leagues'
    | '/schedule'
    | '/tests'
    | '/users'
    | '/video'
    | '/availability/user/$userId'
    | '/evaluation/edit/$gameId'
    | '/games/edit/$gameId'
    | '/journal/user/$userId'
    | '/leagues/edit/$leagueId'
    | '/leagues/league-groups/$groupId'
    | '/leagues/league-groups/new'
    | '/leagues/trip-rankings/$tripRankingId'
    | '/leagues/trip-rankings/new'
    | '/posts/edit/$postId'
    | '/tests/$testId/answers'
    | '/tests/$testId/solve'
    | '/tests/edit/$testId'
    | '/users/edit/$userId'
    | '/leagues/league-groups'
    | '/leagues/trip-rankings'
    | '/leagues/league-groups/edit/$groupId'
    | '/leagues/trip-rankings/edit/$tripRankingId'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_auth/change-password'
    | '/_auth/documents'
    | '/_auth/user-profile'
    | '/_auth/'
    | '/_auth/admin/mail-for-users'
    | '/_auth/admin/reports'
    | '/_auth/availability/users-availability'
    | '/_auth/balance/import'
    | '/_auth/evaluation/$evaluationId'
    | '/_auth/games/$gameId'
    | '/_auth/games/assign'
    | '/_auth/games/import'
    | '/_auth/games/new'
    | '/_auth/games/unconfirmed'
    | '/_auth/invoices/new'
    | '/_auth/journal/balance'
    | '/_auth/journal/expenses'
    | '/_auth/journal/export'
    | '/_auth/journal/my'
    | '/_auth/journal/ranking'
    | '/_auth/journal/users-ranking'
    | '/_auth/leagues/$leagueId'
    | '/_auth/leagues/new'
    | '/_auth/posts/new'
    | '/_auth/schedule/export'
    | '/_auth/schedule/full'
    | '/_auth/schedule/my'
    | '/_auth/tests/new'
    | '/_auth/users/$userId'
    | '/_auth/users/new'
    | '/_auth/video/$videoGroupId'
    | '/_auth/availability/'
    | '/_auth/balance/'
    | '/_auth/invoices/'
    | '/_auth/leagues/'
    | '/_auth/schedule/'
    | '/_auth/tests/'
    | '/_auth/users/'
    | '/_auth/video/'
    | '/_auth/availability/user/$userId'
    | '/_auth/evaluation/edit/$gameId'
    | '/_auth/games/edit/$gameId'
    | '/_auth/journal/user/$userId'
    | '/_auth/leagues/edit/$leagueId'
    | '/_auth/leagues/league-groups/$groupId'
    | '/_auth/leagues/league-groups/new'
    | '/_auth/leagues/trip-rankings/$tripRankingId'
    | '/_auth/leagues/trip-rankings/new'
    | '/_auth/posts/edit/$postId'
    | '/_auth/tests/$testId/answers'
    | '/_auth/tests/$testId/solve'
    | '/_auth/tests/edit/$testId'
    | '/_auth/users/edit/$userId'
    | '/_auth/leagues/league-groups/'
    | '/_auth/leagues/trip-rankings/'
    | '/_auth/leagues/league-groups/edit/$groupId'
    | '/_auth/leagues/trip-rankings/edit/$tripRankingId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_public"
      ]
    },
    "/_auth": {
      "filePath": "_auth/route.tsx",
      "children": [
        "/_auth/change-password",
        "/_auth/documents",
        "/_auth/user-profile",
        "/_auth/",
        "/_auth/admin/mail-for-users",
        "/_auth/admin/reports",
        "/_auth/availability/users-availability",
        "/_auth/balance/import",
        "/_auth/evaluation/$evaluationId",
        "/_auth/games/$gameId",
        "/_auth/games/assign",
        "/_auth/games/import",
        "/_auth/games/new",
        "/_auth/games/unconfirmed",
        "/_auth/invoices/new",
        "/_auth/journal/balance",
        "/_auth/journal/expenses",
        "/_auth/journal/export",
        "/_auth/journal/my",
        "/_auth/journal/ranking",
        "/_auth/journal/users-ranking",
        "/_auth/leagues/$leagueId",
        "/_auth/leagues/new",
        "/_auth/posts/new",
        "/_auth/schedule/export",
        "/_auth/schedule/full",
        "/_auth/schedule/my",
        "/_auth/tests/new",
        "/_auth/users/$userId",
        "/_auth/users/new",
        "/_auth/video/$videoGroupId",
        "/_auth/availability/",
        "/_auth/balance/",
        "/_auth/invoices/",
        "/_auth/leagues/",
        "/_auth/schedule/",
        "/_auth/tests/",
        "/_auth/users/",
        "/_auth/video/",
        "/_auth/availability/user/$userId",
        "/_auth/evaluation/edit/$gameId",
        "/_auth/games/edit/$gameId",
        "/_auth/journal/user/$userId",
        "/_auth/leagues/edit/$leagueId",
        "/_auth/leagues/league-groups/$groupId",
        "/_auth/leagues/league-groups/new",
        "/_auth/leagues/trip-rankings/$tripRankingId",
        "/_auth/leagues/trip-rankings/new",
        "/_auth/posts/edit/$postId",
        "/_auth/tests/$testId/answers",
        "/_auth/tests/$testId/solve",
        "/_auth/tests/edit/$testId",
        "/_auth/users/edit/$userId",
        "/_auth/leagues/league-groups/",
        "/_auth/leagues/trip-rankings/",
        "/_auth/leagues/league-groups/edit/$groupId",
        "/_auth/leagues/trip-rankings/edit/$tripRankingId"
      ]
    },
    "/_public": {
      "filePath": "_public.tsx",
      "children": [
        "/_public/forgot-password",
        "/_public/login"
      ]
    },
    "/_public/forgot-password": {
      "filePath": "_public.forgot-password.tsx",
      "parent": "/_public"
    },
    "/_public/login": {
      "filePath": "_public.login.tsx",
      "parent": "/_public"
    },
    "/_auth/change-password": {
      "filePath": "_auth/change-password.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/documents": {
      "filePath": "_auth/documents.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/user-profile": {
      "filePath": "_auth/user-profile.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/admin/mail-for-users": {
      "filePath": "_auth/admin/mail-for-users.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/admin/reports": {
      "filePath": "_auth/admin/reports.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/availability/users-availability": {
      "filePath": "_auth/availability/users-availability.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/balance/import": {
      "filePath": "_auth/balance/import.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/evaluation/$evaluationId": {
      "filePath": "_auth/evaluation/$evaluationId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/games/$gameId": {
      "filePath": "_auth/games/$gameId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/games/assign": {
      "filePath": "_auth/games/assign.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/games/import": {
      "filePath": "_auth/games/import.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/games/new": {
      "filePath": "_auth/games/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/games/unconfirmed": {
      "filePath": "_auth/games/unconfirmed.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/invoices/new": {
      "filePath": "_auth/invoices/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/journal/balance": {
      "filePath": "_auth/journal/balance.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/journal/expenses": {
      "filePath": "_auth/journal/expenses.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/journal/export": {
      "filePath": "_auth/journal/export.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/journal/my": {
      "filePath": "_auth/journal/my.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/journal/ranking": {
      "filePath": "_auth/journal/ranking.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/journal/users-ranking": {
      "filePath": "_auth/journal/users-ranking.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/$leagueId": {
      "filePath": "_auth/leagues/$leagueId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/new": {
      "filePath": "_auth/leagues/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/posts/new": {
      "filePath": "_auth/posts/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/schedule/export": {
      "filePath": "_auth/schedule/export.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/schedule/full": {
      "filePath": "_auth/schedule/full.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/schedule/my": {
      "filePath": "_auth/schedule/my.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/tests/new": {
      "filePath": "_auth/tests/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/users/$userId": {
      "filePath": "_auth/users/$userId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/users/new": {
      "filePath": "_auth/users/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/video/$videoGroupId": {
      "filePath": "_auth/video/$videoGroupId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/availability/": {
      "filePath": "_auth/availability/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/balance/": {
      "filePath": "_auth/balance/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/invoices/": {
      "filePath": "_auth/invoices/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/": {
      "filePath": "_auth/leagues/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/schedule/": {
      "filePath": "_auth/schedule/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/tests/": {
      "filePath": "_auth/tests/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/users/": {
      "filePath": "_auth/users/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/video/": {
      "filePath": "_auth/video/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/availability/user/$userId": {
      "filePath": "_auth/availability/user.$userId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/evaluation/edit/$gameId": {
      "filePath": "_auth/evaluation/edit.$gameId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/games/edit/$gameId": {
      "filePath": "_auth/games/edit.$gameId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/journal/user/$userId": {
      "filePath": "_auth/journal/user.$userId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/edit/$leagueId": {
      "filePath": "_auth/leagues/edit.$leagueId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/league-groups/$groupId": {
      "filePath": "_auth/leagues/league-groups/$groupId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/league-groups/new": {
      "filePath": "_auth/leagues/league-groups/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/trip-rankings/$tripRankingId": {
      "filePath": "_auth/leagues/trip-rankings/$tripRankingId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/trip-rankings/new": {
      "filePath": "_auth/leagues/trip-rankings/new.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/posts/edit/$postId": {
      "filePath": "_auth/posts/edit.$postId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/tests/$testId/answers": {
      "filePath": "_auth/tests/$testId.answers.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/tests/$testId/solve": {
      "filePath": "_auth/tests/$testId.solve.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/tests/edit/$testId": {
      "filePath": "_auth/tests/edit.$testId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/users/edit/$userId": {
      "filePath": "_auth/users/edit.$userId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/league-groups/": {
      "filePath": "_auth/leagues/league-groups/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/trip-rankings/": {
      "filePath": "_auth/leagues/trip-rankings/index.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/league-groups/edit/$groupId": {
      "filePath": "_auth/leagues/league-groups/edit.$groupId.lazy.tsx",
      "parent": "/_auth"
    },
    "/_auth/leagues/trip-rankings/edit/$tripRankingId": {
      "filePath": "_auth/leagues/trip-rankings/edit.$tripRankingId.lazy.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
